import { combineReducers } from 'redux'
import warehouseReducer from './inventoryReducers/warehouseReducer'
import transferReducer from './inventoryReducers/transferReducer'

const inventoryReducer = combineReducers({
  warehouse: warehouseReducer,
  transfer: transferReducer,
})

export default inventoryReducer
